module.exports = __webpack_public_path__ + "img/answer-questions-step.f68ebc47.svg";